/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePsychoDto } from '../../models/response-psycho-dto';

export interface PsychosControllerFindOne$Params {

/**
 * The tenant of the psycho
 */
  tenant: string;

/**
 * The psycho id
 */
  id: string;
}

export function psychosControllerFindOne(http: HttpClient, rootUrl: string, params: PsychosControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePsychoDto>> {
  const rb = new RequestBuilder(rootUrl, psychosControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePsychoDto>;
    })
  );
}

psychosControllerFindOne.PATH = '/thalea-psychos/psychos/{tenant}/{id}';
